jQuery(document).ready(function() {
    jQuery(".ajax_form").on('submit', function(e){
        e.preventDefault();
        let actionUrl = jQuery(this).attr('action');
        jQuery(".form-error").empty();
        var postData = {};
        for(const field of jQuery(this).serializeArray())
        {
            postData[field.name] = field.value;
        }

        var alertContainer = jQuery("#alert-container");
        if( jQuery(this).find("#alert-container").length )
        {
            alertContainer = jQuery(this).find("#alert-container").first();
        }

        jQuery(this).find('[type="submit"]').first().attr('disabled', 'disabled');
        if (jQuery('#saveNotificationsChange')) {
            jQuery('#saveNotificationsChange').html(`Updating... <div class="spinner-border text-light ml-2" role="status">
            <span class="sr-only">Updating...</span>
          </div>`);
        }
        jQuery('.loading_wrapper').fadeIn();

        submitAjaxForm( actionUrl, postData, alertContainer );
    });

    const urlParams = new URLSearchParams( window.location.search );
    switch(urlParams.get('message'))
    {
        case "addon-success":
            jQuery("#alert-container").addClass("alert-success").text("Your upgrade has processed successfully.").show();
            break;

        case "addon-ineligible":
            jQuery("#alert-container").addClass("alert-danger").text("Your subscription is not eligible to be upgraded at this time.").show();
            break;
    }
});

jQuery(window).load(function() {
    jQuery(".enable-on-load[type='submit']").removeAttr("disabled");
});

function submitAjaxForm( actionUrl, postData, alertContainer = null, selectorsToEnable = null )
{
    jQuery.ajax({
        url: actionUrl,
        async: true,
        type: "POST",
        beforeSend: function(xhr){
            xhr.setRequestHeader('csrf_token', jQuery('meta[name="csrf-token"]').attr('content'));
        },
        data: postData,
        dataType: 'json',
        success: function(response) {
            console.log('Success: ', response);
            if(typeof response.data === 'object' && 'callback' in response.data)
            {
                let args = new Array();
                if('callbackArguments' in response.data)
                {
                    args = response.data.callbackArguments;
                    // callbackArguments MUST be passed as an array from PHP. 
                    // And as an array of arrays if there are multiple variables needed.
                }
                runFunction(response.data.callback, args);
            }
            else
            {
                console.log('Nothing left to do.');
            }

            if( typeof response.data.callbackArguments !== 'object' || !('keepModal' in response.data.callbackArguments[0]) || !response.data.callbackArguments[0].keepModal )
            {
                jQuery('.modal').modal('hide');
            }
            jQuery(alertContainer).removeClass('alert-danger');
            jQuery('.loading_wrapper').fadeOut();

            if(typeof selectorsToEnable == 'string')
            {
                jQuery( selectorsToEnable ).attr('disabled', false);
            }
        },
        error: function(response) {
            console.error(response);
            
            if( 
                typeof response.responseJSON.data === 'object' && 
                'show_message' in response.responseJSON.data && 
                'message' in response.responseJSON.data && 
                response.responseJSON.data.show_message === true
            )
            {
                if( !('keepModal' in response.responseJSON.data) || !response.responseJSON.data.keepModal )
                {
                    jQuery('.modal').modal('hide');
                }
                jQuery(alertContainer).addClass('alert-danger').text( response.responseJSON.data.message ).show();//.delay(10000).fadeOut();
            }
            else
            {
                jQuery(alertContainer).addClass('alert-danger').text( 'An error occurred while processing your request.' ).show();//.delay(10000).fadeOut();
            }

            if( typeof response.responseJSON.data === 'object' && 'errorCallback' in response.responseJSON.data )
            {
                let args = new Array();

                if( 'errorCallbackArguments' in response.responseJSON.data )
                {
                    args = response.responseJSON.data.errorCallbackArguments;
                    // callbackArguments MUST be passed as an array from PHP. 
                    // And as an array of arrays if there are multiple variables needed.
                }
                runFunction( response.responseJSON.data.errorCallback, args );
            }

            jQuery('.loading_wrapper').fadeOut();
            jQuery('.modal, html, body').animate({ scrollTop: 0 }, 'slow');

            //jQuery('alertContainer')[0].scrollIntoView();
        },
        complete: function() {
            jQuery('[type="submit"]').removeAttr('disabled');
            if (jQuery('#saveNotificationsChange')) {
                jQuery('#saveNotificationsChange').html(`Save`);
            }
        },
    });
}

function runFunction(name, args)
{
    var fn = window[name];
    if(typeof fn !== 'function')
        return;

    fn.apply(window, args);
}

function updateProfileSuccess(args)
{
    for ( const [key, value] of Object.entries(args.data) )
    {
        if( jQuery("#subscription-" + args.sub_id + " [data-reload='" + key + "']").length )
        {
            jQuery("#subscription-" + args.sub_id + " [data-reload='" + key + "']").text( value );
        }

        if( key == 'snacker_name' )
        {
            jQuery("#subscription-picker-" + args.sub_id + " .snacker-icon h4").text( value.charAt(0) )
            jQuery("#subscription-picker-" + args.sub_id + " .snacker-name").text( value )
        }
    }
    
    showAlert( args.message );
}

function updateCustomerSuccess(args)
{
    for ( const [key, value] of Object.entries(args.data) )
    {
        if( jQuery("[data-reload='" + key + "']").length )
        {
            jQuery("[data-reload='" + key + "']").text( value );
        }
    }
    showAlert( args.message );

    function hideAccordion(accordion) {
        if(jQuery(accordion).hasClass('show')){
            jQuery(accordion).collapse('hide');
        }
    }

    hideAccordion('#collapseContactInfo');
    hideAccordion('#collapseNotifications');
}

function cancelPlanSuccess(args)
{
    showAlert( args.message );

    if( args.term_data != null )
    {
        jQuery('#subStatusChangeModal').modal('show');
        
        jQuery('#acceptSubStatusChange').on('click', function(){
            simpleRedirect( args.redirect_link );
        });
    }
    else
    {
        simpleRedirect( args.redirect_link );
    }
}

function resumePlanSuccess(args)
{
    showAlert( args.message );
    window.location.reload();
}

function pausePlanSuccess(args)
{
    if( window.location.href.includes('subscription-settings') )
    {
        window.location.reload();
    }
    else
    {
        showAlert( args.message );
    }
}

function updatePlanUnchanged()
{
    showAlert( "Plan unchanged" );
    window.location.reload();
}

function updatePlanSuccess(args)
{
    showAlert( args.message );
    
    if( !window.location.href.includes('subscription-cancel') )
    {
        window.location.reload();
    }
    else
    {
        jQuery("#reasonCantAfford").attr('data-bypass', true);
        jQuery("#reasonCantAfford").removeAttr('data-popup');
    }
}

function updateCardSuccess(args)
{
    showAlert( args.message );
    simpleReload();
}

function loginFailed(args)
{
    simpleRedirect( args.redirect_link );
}

function loginSuccess(args)
{
    simpleRedirect( args.redirect_link );
}

function logout(args)
{
    window.localStorage.clear(); //clear all localstorage
    window.sessionStorage.clear();

    simpleRedirect( args.redirect_link );
}

function addSubscription(args)
{
    //showAlert( args.message );
    jQuery('.loading_wrapper').fadeOut();
    window.location.href = "/";
}

function addToCandybarCart(args)
{
    simpleRedirect(args.link);
}

function updateSelectedAddress(args)
{
    jQuery("#accountCheckoutModal input[name='address']").val( args.id );
    jQuery("#accountCheckoutModal input[name='tax_pct']").val( args.taxPct );
    jQuery("#accountCheckoutModal #address-shipping_name").text( args.shipping_name );
    jQuery("#accountCheckoutModal #address-address").text( args.address + ' ' + args.suite );
    jQuery("#accountCheckoutModal #address-city").text( args.city );
    jQuery("#accountCheckoutModal #address-state").text( args.state );
    jQuery("#accountCheckoutModal #address-zip").text( args.zip );
    jQuery("#accountCheckoutModal #address-country").text( args.country );

    if( args.taxPct == 0)
    {
        jQuery("#accountCheckoutModal .taxValue").text( '--' );
        jQuery("#accountCheckoutModal #totalModalPrice").text( parseFloat( jQuery("#singlePriceModal").text() ).toFixed(2) );
    }
    else
    {
        let qty = parseInt( jQuery("#quantityCollection").val() );
        let basePrice = jQuery("#singlePriceModal").text();
        let taxAmt = parseFloat(args.taxPct) * parseFloat(basePrice) * qty;
        jQuery("#accountCheckoutModal .taxValue").text( parseFloat(taxAmt).toFixed(2) );

        let totalPrice = taxAmt + ( parseFloat(basePrice) * qty );
        jQuery("#accountCheckoutModal #totalModalPrice").text( parseFloat(totalPrice).toFixed(2) );
    }

    jQuery("#editShippingAddressModal").modal('hide');
}

function addedCard(args)
{
    jQuery(".checkoutCardBtn").addClass("d-none");
    jQuery("input[name='source'], input[name='pay_method']").val( args.id );

    let brand = args.brand.replace(' ', '');
    let html = '';
    if( jQuery("body").hasClass("add-subscription") )
    {
        jQuery(".payment-info").removeClass("active");
        html = `
            <div class="payment-info position-relative mb-3 active" data-method="${args.id}">
                <i class="fas fa-check"></i>
                <div class="d-flex align-items-center justify-content-between pb-2">
                    <h6 class="mb-0 card-name">${args.name}</h6>
                    <img class="card-brand" alt="${args.brand} logo" data-brand="${args.brand}"
                        src="https://www.snackcrate.com/wp-content/uploads/2021/10/${brand}.png">
                </div>

                <div class="d-flex align-items-center justify-content-between">
                    <p class="h6 mb-0" id="">
                        <span id="">XXXX XXXX XXXX 
                        <span class="card-last4">${args.last4}</span>
                    </p>
                    <p class="h6 font-size-12 font-weight-semibold mb-0">Valid thru:
                        <span class="card-exp-date">${args.exp}</span>
                    </p>
                </div>
                
            </div>
        `;
        jQuery("#paymentNew .card.card-body .payment-info").first().before( html );

        initializePaymentEditor(jQuery);
    }
    else
    {
        html = `
            <button class="checkoutCardBtn stripe-card" type="button" data-cardid="${args.id}">
                <div class="mb-3">
                    <img id="cc-logo-brand" class="cc-logo" alt="${args.brand} logo" src="https://www.snackcrate.com/wp-content/uploads/2021/10/${brand}.png">
                    <p>${args.name}</p>
                    
                    <p style="font-size: .9rem;">XXXX XXXX XXXX ${args.last4}</p>
                    <p class="valid-thru">Valid thru: ${args.exp} </p>
                </div>

                <svg 
                    class="icon-card-saved icon-checkmark-orange">
                    <use xlink:href="#icon-checkmark-orange"></use>
                    <symbol id="icon-checkmark-orange" viewBox="0 0 32 32">
                        <path fill="#ff9e16" style="fill: var(--color1, #ff9e16)" d="M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"></path>
                        <path fill="#fff" style="fill: var(--color2, #fff)" d="M11.946 23.423l-6.79-6.787c-0.189-0.189-0.305-0.45-0.305-0.738s0.117-0.549 0.305-0.738l1.476-1.478c0.189-0.189 0.45-0.305 0.738-0.305s0.549 0.117 0.738 0.305l4.572 4.572 9.795-9.789c0.189-0.189 0.45-0.305 0.738-0.305s0.549 0.117 0.738 0.305l1.476 1.476c0.189 0.189 0.305 0.45 0.305 0.738s-0.117 0.549-0.305 0.738l-12.007 12.006c-0.189 0.188-0.45 0.305-0.737 0.305s-0.548-0.116-0.737-0.305l0 0z"></path>
                    </symbol>
                </svg>
            </button>    
        `;
        jQuery("#accountCheckoutModal .card-inner-wrap").prepend( html );
    }
    
    jQuery("#addCard").modal('hide');
    jQuery("#accountCheckoutModal").removeClass("shipping-open");
}

function purchaseSuccess(args)
{
    showAlert("Purchase successful");

    if( jQuery("body").hasClass("my-orders") )
    {
        let html = `
        <div class="candybar-orders p-2 p-md-3 p-lg-4 d-flex flex-column">
            <h3 class="h8 h6-md h5-lg font-weight-bold border-bottom pb-1 pb-md-3 mb-md-3 pb-lg-4 mb-lg-4 d-flex align-items-center justify-content-between">
                CandyBar Order #${args.id} is being processed.   
            </h3>
            <p class="h8 h7-md h6-lg text-gray font-weight-medium mb-0 mb-md-1 mb-lg-3" id="userStreet">Your order will ship soon.</p>
            <p class="h8 h7-md h6-lg text-gray font-weight-medium mb-0"></span></p>
        </div>        
        `;

        jQuery(".my-orders .status-body").append(html);
    }

    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1721355838145991');
    fbq('track', 'InitiateCheckout');
    fbq('track', 'Purchase', {
        value: args.value,
        currency: 'USD'
    });
}

function decodeHTMLEntities(text)
{
    var textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
}

function simpleRedirect(link)
{
    let decodedLink = decodeHTMLEntities(link);
    window.location.href = decodedLink;
}

function simpleReload()
{
    window.location.reload();
}

function showAlert(message)
{
    jQuery('#alert-container').addClass('alert-success').text( message ).show().delay(15000).fadeOut();
    jQuery([document.documentElement, document.body]).animate({
        scrollTop: jQuery("#alert-container").offset().top - jQuery("#header").height() - 40
    }, 200);
}

function reviewSubmitted(args)
{
    window.history.replaceState({}, document.title, window.location.href.split('?')[0]);
}

function bundlesUpdated( args )
{
    if( args.action == 'add' )
    {
        jQuery("[data-bundle_id='"+args.id+"'].add-bundle")
            .html('Add To Crate')
            .addClass('d-none')
            .next().removeClass('d-none');
    }
    else
    {
        jQuery("[data-bundle_id='"+args.id+"'].remove-bundle")
            .html('Added <i class="fas fa-check ml-1"></i>')
            .addClass('d-none')
            .prev().removeClass('d-none');

        jQuery("[data-bundle_id='"+args.id+"'].remove-bundle")
            .parent()
            .find('.bundle-err-msg')
            .fadeIn(
                'slow', function () {
                    jQuery(this).delay(3000).fadeOut('slow');
                }
            );
    }

    if(typeof args.newPlan == "string")
    {
        jQuery(".single-subscription[data-subscription='"+args.subscriptionId+"'").attr("data-currentorderplan", args.newPlan);
        jQuery("#currentOrderPlan").val(args.newPlan);
    }
}

function addBundleError( args )
{
    jQuery("[data-bundle_id='"+args.id+"'].add-bundle")
        .text( "Sold Out" )
        .addClass( "btn-dark" )
        .removeClass( "btn-secondary" )
        .attr( "disabled", "disabled" );
}

function hideReviewBtn () 
{
    jQuery('[data-target="#reviewItemModal"]').addClass('d-none'); 
}

function supportOrderReplaceSuccess( args )
{
    showAlert(args.message);

    if( args.label_url != null )
    {
        alert(`Here is your new label url: ${args.label_url}`);
    }
}

function supportOrderUpdateSuccess( args )
{
    showAlert(args.message);
}

function upsellSuccess( args )
{
    showAlert(args.message);
}

function addonSuccess( args )
{
    window.location.href = "/upgrade-thank-you";
    /*
    showAlert(args.message);

    setTimeout( 
        function() {
            window.location.href = "/";
        },
        5000
    );
    */
}

function cancelFunnelEmailSuccess(args)
{
    jQuery(`#${args.closemodal}`).modal('hide');

    jQuery("#cancelThankYouModal").modal('show');
}

function cancelPromoAccepted(args)
{
    showAlert(args.message);

    jQuery('#originalCancelForm input[name="offers_available"]').val(0);
}

function addonPaymentFailedRouter(args)
{
    addonPaymentFailed(args.price);
    jQuery("#modalAddOnPaymentFailed").modal('show');
}